/* import __COLOCATED_TEMPLATE__ from './address-input-type-inverted-dropdowns-jp.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { get, action, computed } from '@ember/object';
import { tagName } from '@ember-decorators/component';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import { isEmpty } from '@ember/utils';
import Component from '@ember/component';
import { isArray } from '@ember/array';
import { isGlobalAddress } from '@square/dashboard-utilities/utils/global-address';
let AddressInputTypeInvertedDropdownsJp = (_dec = tagName(''), _dec2 = readOnly('isLoading'), _dec3 = readOnly('isLoading'), _dec4 = computed('scriptAddresses.@each.script'), _dec5 = computed('scriptAddresses.@each.script'), _dec6 = computed('address'), _dec7 = computed('address', 'address.{adminLevel1,administrativeDistrictLevel1}', 'adminLevel1Property'), _dec8 = computed('adminLevel1Property'), _dec9 = computed('shouldStorePrefectureAsKanji'), _dec(_class = (_class2 = class AddressInputTypeInvertedDropdownsJp extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "flash", _descriptor2, this);
    _initializerDefineProperty(this, "i18n", _descriptor3, this);
    // passed-in
    _defineProperty(this, "address", null);
    _defineProperty(this, "scriptAddresses", null);
    _defineProperty(this, "useNarrowLayout", false);
    _defineProperty(this, "fetchDidFail", null);
    _defineProperty(this, "initialJPStateOptions", null);
    _defineProperty(this, "validatedController", null);
    _defineProperty(this, "labelOverrides", null);
    _defineProperty(this, "shouldStorePrefectureAsKanji", false);
    _defineProperty(this, "useJPScriptAddresses", false);
    // properties
    _defineProperty(this, "isLoading", false);
    _initializerDefineProperty(this, "isFormDisabled", _descriptor4, this);
    _initializerDefineProperty(this, "isPostalCodeSubmitDisabled", _descriptor5, this);
    _defineProperty(this, "stateOptions", null);
    _defineProperty(this, "cityOptions", null);
    _defineProperty(this, "townOptions", null);
  }
  get kanaScriptAddress() {
    return this.scriptAddresses?.find(address => address.script?.toUpperCase() === 'KANA');
  }
  get kanjiScriptAddress() {
    return this.scriptAddresses?.find(address => address.script?.toUpperCase() === 'HANI');
  }
  get adminLevel1Property() {
    return isGlobalAddress(this.address) ? 'administrativeDistrictLevel1' : 'adminLevel1';
  }
  get admin1Level() {
    return this.address[this.adminLevel1Property] ?? null;
  }
  get admin1LevelKeyPath() {
    return `address.${this.adminLevel1Property}`;
  }
  get optionValuePath() {
    return this.shouldStorePrefectureAsKanji ? 'kanji' : 'isoCode';
  }
  didInsertElement(...args) {
    super.didInsertElement(...args);
    const initialOptions = this.initialJPStateOptions;
    if (!isEmpty(initialOptions)) {
      // Set the postal code of script addresses if those are not set
      if (this.useJPScriptAddresses && isEmpty(this.kanjiScriptAddress?.address?.postal_code)) {
        this.setKanjiScriptAddressField('address.postal_code', this.address?.postalCode);
        this.setKanaScriptAddressField('address.postal_code', this.address?.postalCode);
      }
      this.handleStatesResponse(isArray(initialOptions) ? initialOptions : [initialOptions]);
    } else if (!this.useJPScriptAddresses && !isEmpty(this.address?.postalCode) || this.useJPScriptAddresses && !isEmpty(this.kanjiScriptAddress?.address?.postal_code)) {
      this.send('fetchStateOptions');
    } else {
      this.defaultSelectsToServerValues();
    }
  }
  setAdmin1Level(value) {
    if (this.address) {
      this.set(this.admin1LevelKeyPath, value);
    }
  }
  setKanaScriptAddressField(path, value) {
    if (this.kanaScriptAddress) {
      this.kanaScriptAddress.set(path, value);
    }
  }
  setKanjiScriptAddressField(path, value) {
    if (this.kanjiScriptAddress) {
      this.kanjiScriptAddress.set(path, value);
    }
  }
  handleStatesResponse(stateOptions) {
    // filter out invalid options

    const validStateOptions = stateOptions.filter(option => option.isoCode !== '-1');
    if (this.useJPScriptAddresses) {
      if (!isEmpty(validStateOptions)) {
        this.set('stateOptions', validStateOptions);
        const {
          selection,
          value
        } = this.getSelection(validStateOptions, this.admin1Level, this.optionValuePath);
        const {
          selection: kanaSelection,
          value: kanaValue
        } = this.getSelection(validStateOptions, this.admin1Level, 'kana');
        const {
          selection: kanjiSelection,
          value: kanjiValue
        } = this.getSelection(validStateOptions, this.admin1Level, 'kanji');
        if (isEmpty(selection) && isEmpty(kanaSelection)) {
          this.defaultSelectsToServerValues();
        } else {
          this.setKanjiScriptAddressField('address.prefecture', kanjiValue);
          this.setKanaScriptAddressField('address.prefecture', kanaValue);
          this.setKanjiScriptAddressField('address.administrative_district_level_1', value);
          this.setKanaScriptAddressField('address.administrative_district_level_1', value);
          this.setAdmin1Level(value);
          this.send('selectedStateDidChange', selection);
        }
      } else {
        this.setKanjiScriptAddressField('address.prefecture', null);
        this.setKanaScriptAddressField('address.prefecture', null);
        this.setKanaScriptAddressField('address.administrative_district_level_1', null);
        this.setKanjiScriptAddressField('address.administrative_district_level_1', null);
        this.setAdmin1Level(null);
        this.set('stateOptions', null);
        this.send('selectedStateDidChange', null);
      }
    } else {
      if (!isEmpty(validStateOptions)) {
        this.set('stateOptions', validStateOptions);
        const {
          selection,
          value
        } = this.getSelection(validStateOptions, this.admin1Level, this.optionValuePath);
        if (isEmpty(selection)) {
          this.defaultSelectsToServerValues();
        } else {
          this.setAdmin1Level(value);
          this.send('selectedStateDidChange', selection);
        }
      } else {
        this.setAdmin1Level(null);
        this.set('stateOptions', null);
        this.send('selectedStateDidChange', null);
      }
    }
  }

  // If Monk returns nothing for the given postal code, default the selects
  // to current model values.
  defaultSelectsToServerValues() {
    if (this.useJPScriptAddresses) {
      const currentState = this.kanjiScriptAddress?.address?.administrative_district_level_1;
      const currentCity = this.kanjiScriptAddress?.address?.locality;
      const currentTown = this.kanjiScriptAddress?.address?.sublocality;
      const currentStateKana = this.kanaScriptAddress?.address?.administrative_district_level_1;
      const currentCityKana = this.kanaScriptAddress?.address?.locality;
      const currentTownKana = this.kanaScriptAddress?.address?.sublocality;
      if (currentState) {
        const initialState = this.store.createRecord('jp-state', {
          isoCode: currentState,
          kanji: currentState,
          kana: currentStateKana
        });
        this.set('stateOptions', [initialState]);
      }
      if (currentCity) {
        const initialCity = this.store.createRecord('jp-city', {
          kanji: currentCity,
          kana: currentCityKana
        });
        this.set('cityOptions', [initialCity]);
      }
      if (currentTown) {
        const initialTown = this.store.createRecord('jp-town', {
          kanji: currentTown,
          kana: currentTownKana
        });
        this.set('townOptions', [initialTown]);
      }
    } else {
      const currentState = this.admin1Level;
      const currentCity = this.address?.locality;
      const currentTown = this.address?.sublocality;
      if (currentState) {
        const initialState = this.store.createRecord('jp-state', {
          isoCode: currentState,
          kanji: currentState
        });
        this.set('stateOptions', [initialState]);
      }
      if (currentCity) {
        const initialCity = this.store.createRecord('jp-city', {
          kanji: currentCity
        });
        this.set('cityOptions', [initialCity]);
      }
      if (currentTown) {
        const initialTown = this.store.createRecord('jp-town', {
          kanji: currentTown
        });
        this.set('townOptions', [initialTown]);
      }
    }
  }

  // Get the selection (object) that matches the given value (string), or default
  // to the first object if there's only one.
  getSelection(options, currentValue, optionValuePath) {
    let matchingOption;
    let selection = null;
    let value = null;
    if (options && options.get('length') <= 0) {
      return {
        selection,
        value
      };
    }

    // We default to selecting the first option if there's only one
    if (options.get('length') === 1) {
      selection = options.get('firstObject');
    }
    if (!selection && currentValue && (matchingOption = options.findBy(optionValuePath, currentValue))) {
      selection = matchingOption;
    }
    if (selection) {
      value = get(selection, optionValuePath);
      // if (!value) {
      //   value = get(selection.data, optionValuePath);
      // }
    }
    return {
      selection,
      value
    };
  }
  fetchStateOptions() {
    const postalCode = this.useJPScriptAddresses ? this.kanjiScriptAddress?.address.postal_code : this.address?.postalCode;
    if (isEmpty(postalCode)) {
      return;
    }
    this.set('isLoading', true);
    this.flash.clearSheetMessage();
    this.store.queryRecord('jp-state', {
      q: postalCode,
      tree: 2
    }).then(stateOptions => {
      this.flash.clearSheetMessage();
      this.handleStatesResponse([stateOptions]);
    }).catch(() => {
      this.flash.sheetError(this.i18n.t('addressService.validation.postalCode.default'));
      this.handleStatesResponse([]);
    }).finally(() => {
      this.set('isLoading', false);
    });
  }

  // Update *city* options and auto-select when *state* selection changes
  selectedStateDidChange(selectedState) {
    const cityOptions = selectedState && selectedState.get('cities');
    if (this.useJPScriptAddresses) {
      if (cityOptions) {
        this.set('cityOptions', cityOptions);
        const {
          selection,
          value
        } = this.getSelection(cityOptions, this.kanjiScriptAddress?.address?.locality, 'kanji');
        const {
          selection: kanaSelection,
          value: kanaValue
        } = this.getSelection(cityOptions, this.kanaScriptAddress?.address?.locality, 'kana');
        this.setKanjiScriptAddressField('address.locality', value);
        this.setKanaScriptAddressField('address.locality', kanaValue);
        this.send('selectedCityDidChange', selection);
      } else {
        this.setKanjiScriptAddressField('address.locality', null);
        this.setKanaScriptAddressField('address.locality', null);
        this.set('cityOptions', null);
        this.send('selectedCityDidChange', null);
      }
    } else {
      if (cityOptions) {
        this.set('cityOptions', cityOptions);
        const {
          selection,
          value
        } = this.getSelection(cityOptions, this.address?.locality, 'kanji');
        this.set('address.locality', value);
        this.send('selectedCityDidChange', selection);
      } else {
        this.set('address.locality', null);
        this.set('cityOptions', null);
        this.send('selectedCityDidChange', null);
      }
    }
  }

  // Update *town* options and auto-select when *city* selection changes
  selectedCityDidChange(selectedCity) {
    const townOptions = selectedCity && selectedCity.towns;
    if (this.useJPScriptAddresses) {
      if (townOptions) {
        this.set('townOptions', townOptions);
        const {
          selection,
          value
        } = this.getSelection(townOptions, this.kanjiScriptAddress?.address?.sublocality, 'kanji');
        const {
          selection: kanaSelection,
          value: kanaValue
        } = this.getSelection(townOptions, this.kanaScriptAddress?.address?.sublocality, 'kana');
        this.setKanjiScriptAddressField('address.sublocality', value);
        this.setKanaScriptAddressField('address.sublocality', kanaValue);
        this.send('selectedTownDidChange', selection);
      } else {
        this.setKanjiScriptAddressField('address.sublocality', null);
        this.setKanaScriptAddressField('address.sublocality', null);
        this.set('townOptions', null);
        this.send('selectedTownDidChange', null);
      }
    } else {
      if (townOptions) {
        this.set('townOptions', townOptions);
        const {
          selection,
          value
        } = this.getSelection(townOptions, this.address?.sublocality, 'kanji');
        this.set('address.sublocality', value);
        this.send('selectedTownDidChange', selection);
      } else {
        this.set('address.sublocality', null);
        this.set('townOptions', null);
        this.send('selectedTownDidChange', null);
      }
    }
  }
  handleTownDidChange(selectedTown) {
    this.selectedTownDidChange(selectedTown);
    if (this.useJPScriptAddresses) {
      this.setKanjiScriptAddressField('address.sublocality', selectedTown.kanji);
    }
  }
  selectedTownDidChange(selectedTown) {
    const agrex = selectedTown && selectedTown.agrexAddressCode;
    this.set('address.agrexCode', agrex || null);
  }
  scriptAddressLine1DidChange(event) {
    this.setKanjiScriptAddressField('address.address_line_1', event.detail.value);
    this.setKanaScriptAddressField('address.address_line_1', event.detail.value);
  }
  setKanaMunicipality(kanaMunicipality) {
    this.setKanaScriptAddressField('address.sublocality', kanaMunicipality.kana);
  }
  scriptAddressPostalCodeDidChange(event) {
    this.setKanjiScriptAddressField('address.postal_code', event.detail.value);
    this.setKanaScriptAddressField('address.postal_code', event.detail.value);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "flash", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "isFormDisabled", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "isPostalCodeSubmitDisabled", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "kanaScriptAddress", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "kanaScriptAddress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "kanjiScriptAddress", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "kanjiScriptAddress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "adminLevel1Property", [_dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "adminLevel1Property"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "admin1Level", [_dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "admin1Level"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "admin1LevelKeyPath", [_dec8], Object.getOwnPropertyDescriptor(_class2.prototype, "admin1LevelKeyPath"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "optionValuePath", [_dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "optionValuePath"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "fetchStateOptions", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "fetchStateOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedStateDidChange", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedStateDidChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedCityDidChange", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedCityDidChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleTownDidChange", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "handleTownDidChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedTownDidChange", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedTownDidChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "scriptAddressLine1DidChange", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "scriptAddressLine1DidChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setKanaMunicipality", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "setKanaMunicipality"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "scriptAddressPostalCodeDidChange", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "scriptAddressPostalCodeDidChange"), _class2.prototype), _class2)) || _class);
export { AddressInputTypeInvertedDropdownsJp as default };